import React from 'react';
import styles from './ProgressIndicator.module.css';

interface Step {
    label: string;
}

interface ProgressIndicatorProps {
    steps: Step[];
    currentStep: number;
}

export function ProgressIndicator({ steps, currentStep }: ProgressIndicatorProps) {
    return (
        <div className={styles.container}>
            <div className={styles.progressHeader}>
                <span className={styles.stepCounter}>Paso {currentStep + 1} de {steps.length}</span>
                <span className={styles.currentLabel}>{steps[currentStep].label}</span>
            </div>
            <div className={styles.stepsWrapper}>
                {steps.map((step, index) => (
                    <React.Fragment key={index}>
                        <div
                            className={`${styles.stepCircle} ${index <= currentStep ? styles.completed : ''} ${index === currentStep ? styles.active : ''}`}
                        >
                            {index < currentStep ? (
                                <i className="fa-solid fa-check"></i>
                            ) : (
                                <span>{index + 1}</span>
                            )}
                            <span className={styles.stepLabel}>{step.label}</span>
                        </div>
                        {index < steps.length - 1 && (
                            <div className={`${styles.connector} ${index < currentStep ? styles.completed : ''}`}></div>
                        )}
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
}
